import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CardLayout } from '@modules/card/enums/card-layout.enum';

import { Equal3SectionModel } from '../models/equal-3-section.model';
import { SectionDefaultsComponent } from '../section-defaults';

@Component({
  selector: 'mb-equal3-section',
  templateUrl: './equal3-section.component.html',
  styleUrls: ['./equal3-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Equal3SectionComponent extends SectionDefaultsComponent {
  public layout = CardLayout.COLUMN;

  @Input() data!: Equal3SectionModel;
}
